var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"switch-wrap"},[_c('span',{staticClass:"weui-switch",class:{'weui-switch-on': _vm.checked, 'big': _vm.size === 'big'},attrs:{"value":_vm.value},on:{"click":function($event){$event.stopPropagation();return _vm.toggle.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }